import React from 'react';
import LabelValue from 'components/ui/tailwind/label-value';
import { withTranslation } from 'react-i18next';

function InvoiceDocumentPreferences({
  invoiceDocumentPreferences,
  invoiceDocumentPreferenceDocTypesMap,
  t,
}) {
  return (
    <div>
      {invoiceDocumentPreferences.map((pref) => (
        <LabelValue
          key={pref.slug}
          sequence={pref.sequence}
          value={t(
            invoiceDocumentPreferenceDocTypesMap?.[pref.slug]?.localizationSlug,
          )}
        />
      ))}
    </div>
  );
}

export default withTranslation()(InvoiceDocumentPreferences);
